// extracted by mini-css-extract-plugin
module.exports = {"container":"header_container-2MfvT","tagline":"header_tagline-3xXmi","logo":"header_logo-2t3wU"};
    if(module.hot) {
      // 1619198367206
      var cssReload = require("C:/Users/Caleb-VS/Documents/GitHub/century_ac_landing_pages/node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"hmr":true,"locals":true});
      module.hot.dispose(cssReload);
      
    }
  